export default "__VITE_PUBLIC_ASSET__dabb89d2__"